import { Box, IconButton, Link, SxProps, Theme } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

type Props = {
  href: string;
  target?: string;
};

export const MoreLink = ({ href, target }: Props) => {
  return (
    <Link target={target} sx={linkSx} href={href}>
      <Box>MORE</Box>
      <IconButton sx={buttonSx}>
        <ArrowForwardIcon />
      </IconButton>
    </Link>
  );
};

const linkSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  justifyContent: {
    md: "flex-start",
    xs: "flex-end",
  },
  alignItems: "center",
  marginTop: "24px",
};

const buttonSx: SxProps<Theme> = {
  color: "#22A1B9",
  border: "1px solid #D9D9D9",
  marginLeft: "16px",
};
